<template>
  <div class="trackerCard">
    <b-card no-body>
      <b-card-header>
        <h3>Tracker</h3>
      </b-card-header>
      <b-card-body class="position-relative">
        <div v-if="loading" id="overlay">
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
        <b-table-simple bordered fixed>
          <b-tbody>
            <b-tr>
              <b-td>
                TrackerID:
              </b-td>
              <b-td>
                {{ this.id }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                IMEI:
              </b-td>
              <b-td>
                {{ this.trackerData.imei }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                Letze Meldung:
              </b-td>
              <b-td>
                {{ this.trackerData.last_message_at | formatDateTime }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>
                Meldung:
              </b-td>
              <b-td class="scrollable">
                {{ this.trackerData.last_message_data }}
              </b-td>
            </b-tr>

          </b-tbody>
        </b-table-simple>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
    import Resource from '@/api/resource';
    const trackerResource = new Resource('tracker');

    export default {
        name: "TrackerCard",
        props: {
            id: String,
        },
        data () {
          return {
              loading: false,
              noTrackerFound: false,
              trackerData: {
                  imei: "",
                  last_message_at: "",
                  last_message_data: ""
              },
          }
        },
        computed: {
            lang() {
                return this.$store.getters.language;
            },
        },
        created() {
            this.fetchData(this.$props.id);
        },
        methods: {
            fetchData(id) {
                this.loading = true;
                trackerResource.get(id)
                    .then(response => {
                        this.trackerData = response.data.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        if (err.response.status === 404) {
                            this.noTrackerFound = true;
                        }
                        console.log(err);
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>
  #overlay {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 2;
    cursor: pointer;
  }
</style>
